import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Box, Text, Button, Flex, Image } from 'roo-ui/components';
import { ribbon } from 'roo-ui/assets';
import { FormatNumber } from 'components/formatters';
import { getQffAuth } from 'lib/qffAuth';
import { mediaQuery } from 'lib/styledSystem';
import OfferDetails from 'pages/Checkout/ClassicMessaging/OfferDetails';

const login = async () => {
  const qffAuth = await getQffAuth();
  qffAuth.showLoginModal();
};

const UppercaseButton = styled(Button)`
  text-transform: uppercase;
  background-color: ${themeGet('colors.brand.primary')};
  padding: ${themeGet('space.2')} ${themeGet('space.5')};
  width: 100%;

  ${mediaQuery.minWidth.sm} {
    min-width: 188px;
    width: initial;
  }
`;

const LoginPrompt = ({ propertyName, roomType, pointsCost }) => (
  <Box bg="white" borderRadius="default" boxShadow="hard" p={[4, 8]} mb={8}>
    <Text display="block" fontWeight="bold" fontSize="md" mb={4} data-testid="classic-call-to-action">
      Log in to book your selection at {propertyName}.
    </Text>
    <OfferDetails roomType={roomType}>
      <Flex alignItems="center">
        <Image m={0} width="28px" height="28px" src={ribbon} alt="classic offer icon" />
        <Text fontSize="lg" fontWeight="bold" ml={2}>
          <FormatNumber number={pointsCost} decimalPlaces={0} /> pts
        </Text>
      </Flex>
    </OfferDetails>
    <UppercaseButton onClick={login} aria-label="Log in to your frequent flyer account" data-testid="classic-cta-button">
      Let&apos;s login
    </UppercaseButton>
  </Box>
);

LoginPrompt.propTypes = {
  propertyName: PropTypes.string.isRequired,
  pointsCost: PropTypes.number.isRequired,
  roomType: PropTypes.object.isRequired,
};

export default LoginPrompt;
